import { useState } from 'react';
import { View, useWindowDimensions } from 'react-native';
import { Activity, MapPin, Sparkles, Users } from 'lucide-react-native';

import { Tabs } from '@/components/ui';
import { UsuariosScreen } from '@/screens/usuarios/UsuariosScreen';
import { DiagnosticoScreen } from '@/screens/diagnostico/DiagnosticoScreen';
import { AreasScreen } from './AreasScreen';
import { NotasVersionScreen } from './NotasVersionScreen';

type Tab = 'usuarios' | 'areas' | 'diagnostico' | 'notas';

export function ConfiguracionScreen() {
  const { width } = useWindowDimensions();
  const wide = width >= 920;
  const [tab, setTab] = useState<Tab>('usuarios');

  return (
    <View style={{ flex: 1 }}>
      <View style={{ paddingHorizontal: wide ? 28 : 16, paddingTop: 18 }}>
        <Tabs
          active={tab}
          onChange={(t) => setTab(t as Tab)}
          items={[
            { id: 'usuarios', label: 'Equipo y permisos', icon: Users },
            { id: 'areas', label: 'Áreas', icon: MapPin },
            { id: 'diagnostico', label: 'Diagnóstico del sistema', icon: Activity },
            { id: 'notas', label: 'Notas de versión', icon: Sparkles },
          ]}
        />
      </View>
      {tab === 'usuarios' ? (
        <UsuariosScreen />
      ) : tab === 'areas' ? (
        <AreasScreen />
      ) : tab === 'diagnostico' ? (
        <DiagnosticoScreen />
      ) : (
        <NotasVersionScreen />
      )}
    </View>
  );
}
